import { type MotionProps, type Variants } from 'motion/react'

const anim = (variants: Variants): MotionProps => {
	return {
		initial: 'initial',
		animate: 'enter',
		exit: 'exit',
		variants,
	}
}

const opacity: Variants = {
	initial: { opacity: 0 },
	enter: {
		opacity: 1,
		transition: {
			duration: 0.4,
			ease: [0.83, 0, 0.17, 1],
		},
	},
	exit: {
		opacity: 0,
		transition: {
			duration: 0.4,
			ease: [0.83, 0, 0.17, 1],
		},
	},
}

export { anim, opacity }
